import { Dispatch, SetStateAction, useCallback, useState } from 'react';

const STORAGE_KEY = 'stocksFiltersSidebar_collapsed';
const DESKTOP_MIN_WIDTH = 1024;

const isDesktop = () => window.innerWidth >= DESKTOP_MIN_WIDTH;

const readStored = (): boolean => {
    try {
        return localStorage.getItem(STORAGE_KEY) !== 'false';
    } catch {
        return true;
    }
};

// На мобильных панель — выезжающий drawer: всегда закрыт при загрузке и выбор не сохраняется
export const useFiltersSidebarCollapsed = (): [boolean, Dispatch<SetStateAction<boolean>>] => {
    const [collapsed, setCollapsedState] = useState<boolean>(() => (isDesktop() ? readStored() : true));

    const setCollapsed = useCallback<Dispatch<SetStateAction<boolean>>>((value) => {
        setCollapsedState((prev) => {
            const next = typeof value === 'function' ? value(prev) : value;
            if (isDesktop()) {
                try { localStorage.setItem(STORAGE_KEY, String(next)); } catch {}
            }
            return next;
        });
    }, []);

    return [collapsed, setCollapsed];
};
